const dynamicPhoto = {
  UltTitle: 'HitPaw Online Animate Old Photos',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  week: 'week',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
  monthTotalPrice: '$7.99 Billed Monthly',
  yearTotalPrice: '$47.99 Billed Annually',
  NoImageSizeLimits: 'No Image Size Limits',
  UnlimitedImageUploads: 'Unlimited Image Uploads',
  DownloadWithoutWatermark: 'Download HD Image with No Watermark',
  DownloadGif: 'Download Video as GIF',
};

export default dynamicPhoto;
